// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_centered-col__-NXr9 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.styles_hide-scrollbar__YQfBc, .styles_container__Tft09 .styles_header__aQg7u {
  -ms-overflow-style: none;
  scrollbar-width: none; }
  .styles_hide-scrollbar__YQfBc::-webkit-scrollbar, .styles_container__Tft09 .styles_header__aQg7u::-webkit-scrollbar {
    display: none; }

.styles_singleLineText__X-a2I, .styles_container__Tft09 .styles_header__aQg7u h2 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.styles_width-fill-available__dOhvr {
  width: 100%;
  /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  width: fill-available; }

.styles_height-fill-available__Rxzdc {
  height: 100%;
  /* WebKit-based browsers will ignore this. */
  height: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  height: fill-available; }

.styles_backdrop__7R3mZ {
  position: fixed;
  top: 0rem;
  left: 0rem;
  width: 0vw;
  height: 0vh;
  background-color: rgba(0, 0, 0, 0);
  transition: 3.6s background-color; }
  .styles_backdrop__7R3mZ.styles_open__2x1Sq {
    z-index: 35;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0rem;
    left: 0rem;
    width: 100vw;
    height: 100vh; }

.styles_container__Tft09 {
  position: fixed;
  transition: 1s all;
  background-color: transparent;
  box-shadow: 3rem 18rem 18rem #8080805c, 3rem 18rem 18rem #80808080; }
  .styles_container__Tft09.styles_open__2x1Sq {
    background-color: #fff;
    z-index: 36; }
    .styles_container__Tft09.styles_open__2x1Sq > div {
      max-height: 100vh; }
  .styles_container__Tft09.styles_bottom__BbqkU {
    bottom: 0rem;
    height: 0rem;
    right: 0rem;
    width: 100vw; }
    .styles_container__Tft09.styles_bottom__BbqkU.styles_open__2x1Sq {
      height: 90vh; }
  .styles_container__Tft09.styles_right__HuWvz {
    bottom: 0rem;
    height: 100vh;
    right: 0rem;
    width: 0vw; }
    .styles_container__Tft09.styles_right__HuWvz.styles_open__2x1Sq {
      width: 90vw; }
      @media (max-width: 768px) {
        .styles_container__Tft09.styles_right__HuWvz.styles_open__2x1Sq {
          width: 100vw; } }
      .styles_container__Tft09.styles_right__HuWvz.styles_open__2x1Sq.styles_md__EtRpK {
        width: 54vw; }
        @media (max-width: 768px) {
          .styles_container__Tft09.styles_right__HuWvz.styles_open__2x1Sq.styles_md__EtRpK {
            width: 72vw; } }
  .styles_container__Tft09.styles_left__dwiqb {
    bottom: 0rem;
    height: 100vh;
    left: 0rem;
    width: 0vw; }
    .styles_container__Tft09.styles_left__dwiqb.styles_open__2x1Sq {
      width: 90vw; }
      @media (max-width: 768px) {
        .styles_container__Tft09.styles_left__dwiqb.styles_open__2x1Sq {
          width: 100vw; } }
      .styles_container__Tft09.styles_left__dwiqb.styles_open__2x1Sq.styles_sm__\\+kFsm {
        width: 18vw; }
        @media (max-width: 768px) {
          .styles_container__Tft09.styles_left__dwiqb.styles_open__2x1Sq.styles_sm__\\+kFsm {
            width: 72vw; } }
      .styles_container__Tft09.styles_left__dwiqb.styles_open__2x1Sq.styles_md__EtRpK {
        width: 36vw; }
        @media (max-width: 768px) {
          .styles_container__Tft09.styles_left__dwiqb.styles_open__2x1Sq.styles_md__EtRpK {
            width: 72vw; } }
  .styles_container__Tft09 .styles_header__aQg7u {
    width: 100%;
    padding: unset;
    overflow-x: scroll; }
    .styles_container__Tft09 .styles_header__aQg7u h2 {
      max-width: 90%; }
      @media (max-width: 768px) {
        .styles_container__Tft09 .styles_header__aQg7u h2 {
          min-width: 50%;
          font-size: 0.72rem; } }
    .styles_container__Tft09 .styles_header__aQg7u .styles_chevron__6XptV {
      margin: 0rem 1rem; }
  .styles_container__Tft09 .styles_footer__hgUUq {
    width: -webkit-fill-available;
    max-width: 100%;
    position: absolute; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/styles/classes.scss","webpack://./src/modules/Core/sub-modules/ui-kit/components/Drawer/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss","webpack://./src/modules/Core/styles/mixins.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB;EACxB,qBAAqB,EAAA;EAFvB;IAII,aAAa,EAAA;;AAIjB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,WAAW;EACY,4CAAA;EACvB,6BAA6B;EAAE,6CAAA;EAC/B,qBAAqB,EAAA;;AAGvB;EACE,YAAY;EACY,4CAAA;EACxB,8BAA8B;EAAE,6CAAA;EAChC,sBAAsB,EAAA;;AC5BxB;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,kCAAkC;EAClC,iCAAiC,EAAA;EAPnC;IASI,WAAW;IACX,oCAAoC;IACpC,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa,EAAA;;AAIjB;EACE,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,kECXgB,EAAA;EDOlB;IAQI,sBAAsB;IACtB,WAAW,EAAA;IATf;MAWM,iBAAiB,EAAA;EAXvB;IAgBI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY,EAAA;IAnBhB;MAqBM,YAAY,EAAA;EArBlB;IA0BI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU,EAAA;IA7Bd;MA+BM,WAAW,EAAA;ME7Cf;QFcF;UAiCQ,YAAY,EAAA,EAQf;MAzCL;QAoCQ,WAAW,EAAA;QElDjB;UFcF;YAsCU,WAAW,EAAA,EAEd;EAxCP;IA6CI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,UAAU,EAAA;IAhDd;MAkDM,WAAW,EAAA;MEhEf;QFcF;UAoDQ,YAAY,EAAA,EAcf;MAlEL;QAuDQ,WAAW,EAAA;QErEjB;UFcF;YAyDU,WAAW,EAAA,EAEd;MA3DP;QA6DQ,WAAW,EAAA;QE3EjB;UFcF;YA+DU,WAAW,EAAA,EAEd;EAjEP;IAsEI,WAAW;IACX,cAAc;IACd,kBAAkB,EAAA;IAxEtB;MA4EM,cAAc,EAAA;ME1FlB;QFcF;UA8EQ,cAAc;UACd,kBAAkB,EAAA,EAErB;IAjFL;MAmFM,iBAAiB,EAAA;EAnFvB;IAwFI,6BAA6B;IAC7B,eAAe;IACf,kBAAkB,EAAA","sourcesContent":[".centered-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.hide-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.singleLineText {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.width-fill-available {\n  width: 100%;\n  width: -moz-available; /* WebKit-based browsers will ignore this. */\n  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  width: fill-available;\n}\n\n.height-fill-available {\n  height: 100%;\n  height: -moz-available; /* WebKit-based browsers will ignore this. */\n  height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  height: fill-available;\n}\n","@import \"src/modules/Core/styles/mixins.scss\";\n@import \"src/modules/Core/styles/variables.scss\";\n@import \"src/modules/Core/styles/classes.scss\";\n\n.backdrop {\n  position: fixed;\n  top: 0rem;\n  left: 0rem;\n  width: 0vw;\n  height: 0vh;\n  background-color: rgba(0, 0, 0, 0);\n  transition: 3.6s background-color;\n  &.open {\n    z-index: 35;\n    background-color: rgba(0, 0, 0, 0.5);\n    top: 0rem;\n    left: 0rem;\n    width: 100vw;\n    height: 100vh;\n  }\n}\n\n.container {\n  position: fixed;\n  transition: 1s all;\n  background-color: transparent;\n  box-shadow:\n    3rem 18rem 18rem $grey36,\n    3rem 18rem 18rem $grey50;\n  &.open {\n    background-color: #fff;\n    z-index: 36;\n    & > div {\n      max-height: 100vh;\n    }\n  }\n\n  &.bottom {\n    bottom: 0rem;\n    height: 0rem;\n    right: 0rem;\n    width: 100vw;\n    &.open {\n      height: 90vh;\n    }\n  }\n\n  &.right {\n    bottom: 0rem;\n    height: 100vh;\n    right: 0rem;\n    width: 0vw;\n    &.open {\n      width: 90vw;\n      @include mobile {\n        width: 100vw;\n      }\n      &.md {\n        width: 54vw;\n        @include mobile {\n          width: 72vw;\n        }\n      }\n    }\n  }\n\n  &.left {\n    bottom: 0rem;\n    height: 100vh;\n    left: 0rem;\n    width: 0vw;\n    &.open {\n      width: 90vw;\n      @include mobile {\n        width: 100vw;\n      }\n      &.sm {\n        width: 18vw;\n        @include mobile {\n          width: 72vw;\n        }\n      }\n      &.md {\n        width: 36vw;\n        @include mobile {\n          width: 72vw;\n        }\n      }\n    }\n  }\n\n  & .header {\n    width: 100%;\n    padding: unset;\n    overflow-x: scroll;\n    @extend .hide-scrollbar;\n    & h2 {\n      @extend .singleLineText;\n      max-width: 90%;\n      @include mobile {\n        min-width: 50%;\n        font-size: 0.72rem;\n      }\n    }\n    & .chevron {\n      margin: 0rem 1rem;\n    }\n  }\n\n  & .footer {\n    width: -webkit-fill-available;\n    max-width: 100%;\n    position: absolute;\n  }\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n","// @import \"src/modules/Core/styles/mixins.scss\";\n@mixin respond-to($breakpoint) {\n  @media (max-width: $breakpoint) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin multilineText($lines){\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: -webkit-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centered-col": `styles_centered-col__-NXr9`,
	"hide-scrollbar": `styles_hide-scrollbar__YQfBc`,
	"container": `styles_container__Tft09`,
	"header": `styles_header__aQg7u`,
	"singleLineText": `styles_singleLineText__X-a2I`,
	"width-fill-available": `styles_width-fill-available__dOhvr`,
	"height-fill-available": `styles_height-fill-available__Rxzdc`,
	"backdrop": `styles_backdrop__7R3mZ`,
	"open": `styles_open__2x1Sq`,
	"bottom": `styles_bottom__BbqkU`,
	"right": `styles_right__HuWvz`,
	"md": `styles_md__EtRpK`,
	"left": `styles_left__dwiqb`,
	"sm": `styles_sm__+kFsm`,
	"chevron": `styles_chevron__6XptV`,
	"footer": `styles_footer__hgUUq`
};
export default ___CSS_LOADER_EXPORT___;
